import React, { Fragment } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Loader from "../components/Loader";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

import { SITENAMEALIAS, ASSETS, COUNTRYLIST, FILEPATH } from "../utils/init";
import {
  showToast,
  showHttpError,
  handleCurrencyDetiails,
  handleDynamicCurrencyDetiails,
  showConfirm,
  handleNetworkDetails,
  initialiseNetwork,
  getCurrencyWiseTxnCharge,
} from "../utils/library";
import { Link, withRouter } from "react-router-dom";
import {
  addNewEmailBill,
  GetMerchantSettings,
  GetMarketPrice,
  FetchUsdBtcLedgerAmount,
  FetchMerchantSettings
} from "../utils/service";

import { QRCodeSVG } from "qrcode.react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const styles = {
  pageWrapper: { padding: "36px 24px 60px" },
  backRow: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    marginBottom: "28px",
  },
  backBtn: {
    width: "38px",
    height: "38px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color-less)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    color: "var(--text-color)",
    fontSize: "15px",
    transition: "all 0.2s",
  },
  pageTitle: {
    fontSize: "24px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: 0,
  },
  pageSubtitle: { fontSize: "13px", opacity: 0.5, margin: "4px 0 0" },
  card: {
    background: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid var(--body-color-less2)",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    marginBottom: "24px",
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "20px 28px",
    borderBottom: "1px solid var(--body-color-less2)",
  },
  cardHeaderIcon: {
    width: "36px",
    height: "36px",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
  },
  cardHeaderTitle: {
    fontSize: "16px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: 0,
  },
  cardBody: { padding: "24px 28px" },
  formGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" },
  formGroup: { display: "flex", flexDirection: "column", gap: "6px" },
  formGroupFull: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    gridColumn: "1 / -1",
  },
  label: {
    fontSize: "12px",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "0.3px",
    color: "var(--text-color)",
    opacity: 0.7,
  },
  input: {
    padding: "10px 14px",
    fontSize: "14px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
  },
  select: {
    padding: "10px 14px",
    fontSize: "14px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
    appearance: "auto",
  },
  errorText: { fontSize: "11px", color: "#ef4444", marginTop: "2px" },
  checkboxRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    gridColumn: "1 / -1",
    padding: "4px 0",
  },
  checkbox: {
    width: "16px",
    height: "16px",
    accentColor: "var(--btn-color)",
    cursor: "pointer",
  },
  checkboxLabel: {
    fontSize: "13px",
    fontWeight: "500",
    color: "var(--text-color)",
    cursor: "pointer",
  },
  th: {
    padding: "12px 14px",
    fontSize: "11px",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    color: "var(--text-color)",
    opacity: 0.5,
    borderBottom: "1px solid var(--body-color-less2)",
    textAlign: "left",
    background: "transparent",
  },
  td: {
    padding: "10px 14px",
    fontSize: "14px",
    color: "var(--text-color)",
    borderBottom: "1px solid var(--body-color-less2)",
    verticalAlign: "middle",
  },
  tableInput: {
    padding: "8px 12px",
    fontSize: "13px",
    borderRadius: "8px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
  },
  addItemBtn: {
    padding: "8px 20px",
    background: "transparent",
    border: "1px dashed var(--body-color-less2)",
    borderRadius: "10px",
    color: "var(--btn-color)",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    marginBottom: "16px",
  },
  deleteBtn: {
    width: "32px",
    height: "32px",
    borderRadius: "8px",
    border: "none",
    background: "rgba(239,68,68,0.1)",
    color: "#ef4444",
    fontSize: "14px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  totalRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 28px",
    background: "var(--body-color)",
    borderRadius: "0 0 16px 16px",
    borderTop: "2px solid var(--body-color-less2)",
  },
  totalLabel: {
    fontSize: "14px",
    fontWeight: "700",
    color: "var(--text-color)",
  },
  totalAmount: {
    fontSize: "16px",
    fontWeight: "700",
    color: "var(--btn-color)",
    fontFamily: "'SF Mono', 'Fira Code', monospace",
  },
  infoTip: {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    marginLeft: "6px",
    cursor: "help",
  },
  btnPrimary: {
    padding: "12px 36px",
    background: "var(--btn-color)",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    letterSpacing: "0.3px",
  },
  btnPrimaryDisabled: {
    padding: "12px 36px",
    background: "var(--btn-color)",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "not-allowed",
    opacity: 0.5,
    letterSpacing: "0.3px",
  },
  submitFooter: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "0 4px",
    marginTop: "8px",
  },
  paymentLinkCard: {
    background: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid var(--body-color-less2)",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    marginBottom: "24px",
    padding: "24px 28px",
    marginTop: "20px",
  },
  paymentLinkBox: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "10px 14px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
  },
  paymentLinkInput: {
    flex: 1,
    border: "none",
    background: "transparent",
    fontSize: "13px",
    color: "var(--text-color)",
    fontFamily: "'SF Mono', 'Fira Code', monospace",
    outline: "none",
    width: "100%",
  },
  copyBtn: {
    padding: "7px 16px",
    borderRadius: "8px",
    border: "1px solid var(--btn-color)",
    background: "transparent",
    color: "var(--btn-color)",
    fontSize: "12px",
    fontWeight: "600",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
  },
  tabContainer: {
    display: "flex",
    background: "var(--body-color)",
    borderRadius: "12px",
    padding: "4px",
    border: "1px solid var(--body-color-less2)",
    marginBottom: "16px",
    gap: "4px",
  },
  tab: {
    flex: 1,
    padding: "10px 16px",
    borderRadius: "9px",
    border: "none",
    background: "transparent",
    color: "var(--text-color)",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    transition: "all 0.2s ease",
    opacity: 0.6,
  },
  tabActive: {
    flex: 1,
    padding: "10px 16px",
    borderRadius: "9px",
    border: "none",
    background: "var(--btn-color)",
    color: "#fff",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
  },
  tabContent: { padding: "16px 0 0" },
  buttonSizeOptions: { display: "flex", gap: "10px", flexWrap: "wrap" },
  sizeBtn: {
    padding: "8px 18px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    fontSize: "12px",
    fontWeight: "600",
    cursor: "pointer",
  },
  sizeBtnActive: {
    padding: "8px 18px",
    borderRadius: "10px",
    border: "1px solid var(--btn-color)",
    background:
      "linear-gradient(135deg, color-mix(in srgb, var(--btn-color) 12%, transparent), color-mix(in srgb, var(--btn-color) 4%, transparent))",
    color: "var(--btn-color)",
    fontSize: "12px",
    fontWeight: "600",
    cursor: "pointer",
  },
  codeArea: {
    width: "100%",
    minHeight: "120px",
    padding: "14px 16px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    fontSize: "12px",
    fontFamily: "'SF Mono', 'Fira Code', monospace",
    resize: "vertical",
    outline: "none",
    boxSizing: "border-box",
  },
  previewBox: {
    padding: "24px",
    borderRadius: "10px",
    border: "1px dashed var(--body-color-less2)",
    background: "var(--body-color)",
    textAlign: "center",
    minHeight: "80px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  previewPlaceholder: {
    fontSize: "13px",
    color: "var(--text-color)",
    opacity: 0.4,
  },
  sectionDivider: {
    borderTop: "1px solid var(--body-color-less2)",
    margin: "8px 0",
  },
};

class NewEmailbilling extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      totalAmount: "0.00",
      action: "add",
      items: [],
      assets: [],
      checked: false,
      isRecurringBillChecked: false,
      selectedAsset: {},
      selectedDate: new Date(),
      formatedDate: "",
      emailAddr: false,
      verifyBtn: true,
      custName: false,
      addr1: false,
      addr2: false,
      city: false,
      stateName: false,
      zipcode: false,
      billNumber: false,
      itemErrors: {},
      priceErrors: {},
      quantityErrors: {},
      networkArray: [],
      network: "",
      emailBillId: "",
      buttonHtml: "",
      activeGenerateTab: "button",
      selectedButtonSize: "",
      showPreviewForButton: false,
      showPreviewForHyperlink: false,
      showPreviewForQrCode: false,
      qrCodeLink: "",
      encodedValue: "",
      previewFormAction: "",
      buttonImageUrl: "",
      selectedQty: 1,
      // ── Processing Fee ──
      processingFeeHandling: "customer",
      // ── txn charge for selected currency ──
      txnCharge: null,
    };

    this.handleChange = this.handleChange.bind(this);

    this.emailRef = React.createRef();
    this.firstNameRef = React.createRef();
    this.address1Ref = React.createRef();
    this.address2Ref = React.createRef();
    this.cityRef = React.createRef();
    this.stateRef = React.createRef();
    this.countryRef = React.createRef();
    this.zipRef = React.createRef();
    this.billNumberRef = React.createRef();
    this.amountRef = React.createRef();
  }

  handleChange() {
    this.setState({ checked: !this.state.checked });
  }

  // ── Fetch txn charge for the given asset code and store in state ──
  fetchTxnCharge = async (assetCode) => {
    const charge = await getCurrencyWiseTxnCharge(assetCode);
    this.setState({ txnCharge: charge });
  };

  calculateTotalAmount = () => {
    let row = this.state.items;
    let total = 0;
    for (let i = 0; i < row.length; i++) {
      if (row[i].qty != "" && row[i].price != "") {
        total = total + parseFloat(row[i].qty) * parseFloat(row[i].price);
      }
    }
    let totalStr = parseFloat(total).toFixed(6);
    if (totalStr.replace(".", "").replace(/^0+/, "").length > 30) {
      showToast("error", "Total amount must not exceed 30 digits");
      this.setState({ totalAmount: totalStr, verifyBtn: true });
    } else {
      this.setState({ totalAmount: totalStr });
    }
  };

  handleDateChange = (date) => {
    date = new Date(date);
    let year = date.getFullYear();
    let month = parseInt(date.getMonth()) + 1;
    if (parseInt(month) < 10) month = "0" + month;
    let day = date.getDate();
    if (parseInt(day) < 10) day = "0" + day;
    let formatedDate = year + "-" + month + "-" + day;
    console.log("Selected Date ", formatedDate);
    this.setState({ selectedDate: date, formatedDate: formatedDate });
  };

  handleEmailBilling = () => {
    // Validate line items
    let itemErrors = {};
    let priceErrors = {};
    let quantityErrors = {};
    let hasLineItemError = false;
    let items = this.state.items;

    if (items.length === 0) {
      showToast("error", "Please add at least one line item");
      return;
    }

    for (let i = 0; i < items.length; i++) {
      let row = items[i].row;
      if (!items[i].item || items[i].item.trim() === "") {
        itemErrors[row] = "Item name is required";
        hasLineItemError = true;
      } else if (!/^[a-zA-Z0-9 -]+$/.test(items[i].item)) {
        itemErrors[row] = "Please insert valid item name";
        hasLineItemError = true;
      }
      if (!items[i].fiat_price && (items[i].price === 0 || items[i].price === "0" || items[i].price === 0.0)) {
        priceErrors[row] = "Price is required";
        hasLineItemError = true;
      } else if (items[i].fiat_price && String(items[i].fiat_price).replace(".", "").length > 20) {
        priceErrors[row] = "Price must not exceed 20 digits";
        hasLineItemError = true;
      } else if (items[i].fiat_price && String(items[i].fiat_price).includes(".") && String(items[i].fiat_price).split(".")[1].length > 8) {
        priceErrors[row] = "Price must not exceed 8 decimal places";
        hasLineItemError = true;
      }
      if (!items[i].qty || items[i].qty === 0 || items[i].qty === "0") {
        quantityErrors[row] = "Quantity is required";
        hasLineItemError = true;
      } else if (String(items[i].qty).replace(".", "").length > 20) {
        quantityErrors[row] = "Quantity must not exceed 20 digits";
        hasLineItemError = true;
      } else if (String(items[i].qty).includes(".") && String(items[i].qty).split(".")[1].length > 8) {
        quantityErrors[row] = "Quantity must not exceed 8 decimal places";
        hasLineItemError = true;
      }
    }

    if (hasLineItemError) {
      this.setState({ itemErrors, priceErrors, quantityErrors });
      showToast("error", "Please fill in all required line item fields");
      return;
    }

    // Validate total amount does not exceed 30 digits
    let totalStr = this.state.totalAmount.replace(".", "").replace(/^0+/, "");
    if (totalStr.length > 30) {
      showToast("error", "Total amount must not exceed 30 digits");
      return;
    }

    if (
      this.emailRef.current.value != "" &&
      this.firstNameRef.current.value != "" &&
      this.billNumberRef.current.value != "" &&
      this.state.items != ""
    ) {
      let payload = {
        email: this.emailRef.current.value,
        name: this.firstNameRef.current.value,
        currency_id: this.state.selectedAsset.assetId,
        item_json: JSON.stringify(this.state.items),
        due_date: this.state.formatedDate,
        bill_number: this.billNumberRef.current.value,
        total_amount: this.state.totalAmount,
        merchant_id: parseInt(
          localStorage.getItem(SITENAMEALIAS + "_merchant_id")
        ),
        network: this.state.network,
        // ── Processing fee field ──
        is_processing_fee_applied:
          this.state.processingFeeHandling === "customer" ? 1 : 0,
      };

      if (!this.state.isRecurringBillChecked) {
        payload["recurring_bill"] = 0;
      } else {
        payload["recurring_bill"] = 1;
      }

      if (
        this.state.checked == true &&
        this.address1Ref.current.value != "" &&
        this.stateRef.current.value != "" &&
        this.countryRef.current.value != "" &&
        this.cityRef.current.value != "" &&
        this.zipRef.current.value != ""
      ) {
        payload["address_l_1"] = this.address1Ref.current.value;
        payload["address_l_2"] = this.address2Ref.current.value;
        payload["state"] = this.stateRef.current.value;
        payload["country"] = this.countryRef.current.value;
        payload["city"] = this.cityRef.current.value;
        payload["zip"] = this.zipRef.current.value;
      } else {
        payload["address_l_1"] = "";
        payload["address_l_2"] = "";
        payload["state"] = "";
        payload["country"] = "";
        payload["city"] = "";
        payload["zip"] = "";
      }

      let items = this.state.items;
      let arr = [];
      for (let i = 0; i < items.length; i++) {
        let obj = {};
        obj["item_name"] = items[i].item;
        obj["item_price"] = items[i].price;
        obj["item_quantity"] = items[i].qty;
        obj["fiat_price"] = items[i].fiat_price;
        arr.push(obj);
      }
      payload["item_json"] = JSON.stringify(arr);

      if (this.state.action == "add") {
        console.log("xpayload", payload);
        addNewEmailBill(payload)
          .then(
            function (res) {
              this.setState({ showLoader: false });
              let response = res.data;
              let errorObj = response[response.length - 1];
              console.log("erroObj", response, errorObj);
              if (errorObj.error != "0") {
                showToast("error", errorObj.error_msg);
              } else {
                this.setState({
                  emailBillId: errorObj.id,
                  encodedValue: btoa(errorObj.id),
                });
                showToast("success", "Email billing saved successfully");
              }
            }.bind(this)
          )
          .catch(
            function (err) {
              this.setState({ showLoader: false });
              showHttpError(err);
            }.bind(this)
          );
      }
    } else {
      showToast("error", "Please provide all the fields");
    }
  };

  addNewTableRow = () => {
    let rowLength = this.state.items.length;
    let obj = { row: rowLength + 1, item: "", qty: 0, price: 0.0 };
    let item = this.state.items;
    item.push(obj);
    this.setState({ items: item }, () => {
      this.calculateTotalAmount();
    });
  };

  handleBack = () => {
    this.props.history.push("/email-billing");
  };

  handleDeleteRow = (row) => {
    let array = this.state.items;
    let removeIndex = array.map((item) => item.row).indexOf(row);
    array.splice(removeIndex, 1);
    let itemErrors = { ...this.state.itemErrors };
    let priceErrors = { ...this.state.priceErrors };
    let quantityErrors = { ...this.state.quantityErrors };
    delete itemErrors[row];
    delete priceErrors[row];
    delete quantityErrors[row];
    this.setState({ items: array, itemErrors, priceErrors, quantityErrors }, () => {
      this.calculateTotalAmount();
    });
  };

  handleEmail = (e) => {
    let elm = e.target.value;
    let Regex = /^[a-zA-Z0-9._%+-]{1,30}@[a-zA-Z0-9-]{1,30}\.[a-zA-Z]{2,}$/;
    if (Regex.test(elm)) {
      this.setState({ emailAddr: false, verifyBtn: false });
    } else {
      this.setState({ emailAddr: true, verifyBtn: true });
      e.target.value = "";
    }
  };

  handleCustName = (e) => {
    let elm = e.target.value;
    let Regex = /^[a-zA-Z-]{2,50}( [a-zA-Z-]{2,50})?$/;
    if (Regex.test(elm)) {
      this.setState({ custName: false, verifyBtn: false });
    } else {
      this.setState({ custName: true, verifyBtn: true });
      e.target.value = "";
    }
  };

  handleAddr1 = (e) => {
    let elm = e.target.value;
    let Regex = /^[a-zA-Z0-9\s\/\.,-]+$/;
    if (Regex.test(elm)) {
      this.setState({ addr1: false, verifyBtn: false });
    } else {
      this.setState({ addr1: true, verifyBtn: true });
      e.target.value = "";
    }
  };

  handleAddr2 = (e) => {
    let elm = e.target.value;
    let Regex = /^[a-zA-Z0-9\s\/\.,-]+$/;
    if (Regex.test(elm)) {
      this.setState({ addr2: false, verifyBtn: false });
    } else {
      this.setState({ addr2: true, verifyBtn: true });
      e.target.value = "";
    }
  };

  handleCity = (e) => {
    let elm = e.target.value;
    let Regex = /^[A-Za-z ]+$/;
    if (Regex.test(elm)) {
      this.setState({ city: false, verifyBtn: false });
    } else {
      this.setState({ city: true, verifyBtn: true });
      e.target.value = "";
    }
  };

  handleState = (e) => {
    let elm = e.target.value;
    let Regex = /^[A-Za-z ]+$/;
    if (Regex.test(elm)) {
      this.setState({ stateName: false, verifyBtn: false });
    } else {
      this.setState({ stateName: true, verifyBtn: true });
      e.target.value = "";
    }
  };

  handleZipcode = (e) => {
    let elm = e.target.value;
    let Regex = /^[a-zA-Z0-9 ]{1,15}$/;
    if (Regex.test(elm)) {
      this.setState({ zipcode: false, verifyBtn: false });
    } else {
      this.setState({ zipcode: true, verifyBtn: true });
      e.target.value = "";
    }
  };

  handleBillNo = (e) => {
    let elm = e.target.value;
    let Regex = /^[a-zA-Z0-9 ]{1,15}$/;
    if (Regex.test(elm)) {
      this.setState({ billNumber: false, verifyBtn: false });
    } else {
      this.setState({ billNumber: true, verifyBtn: true });
      e.target.value = "";
    }
  };

  handleItemName = (row, e) => {
    let elm = e.target.value;
    let Regex = /^[a-zA-Z0-9 -]+$/;
    let itemErrors = { ...this.state.itemErrors };
    if (elm.trim() === "") {
      itemErrors[row] = "Item name is required";
      this.setState({ itemErrors, verifyBtn: true });
    } else if (!Regex.test(elm)) {
      itemErrors[row] = "Please insert valid item name";
      this.setState({ itemErrors, verifyBtn: true });
      e.target.value = "";
    } else {
      delete itemErrors[row];
      this.setState({ itemErrors, verifyBtn: false });
    }
  };

   renderMerchantProcessingFeeType = async () => {
      let payload = {
            merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
          };
          this.setState({ showLoader: true });
      
          FetchMerchantSettings(payload)
            .then(
              function (res) {
                this.setState({ showLoader: false });
                let response = res.data[0];
                if (response.error != "0") {
                  showToast("error", response.error_msg);
                } else {
                  let processingFeesType = response.is_processing_fee_enabled;
                  this.setState({
                    processingFeeHandling: parseInt(processingFeesType) === 1 ? 'customer' : 'merchant',
                  });
                }
              }.bind(this)
            )
            .catch(
              function (err) {
                this.setState({ showLoader: false });
                console.log("err", err);
                showHttpError(err);
              }.bind(this)
            );
    }

  handlePrice = (row, e) => {
    let elm = e.target.value;
    let Regex = /^[0-9]+(\.[0-9]+)?$/;
    let priceErrors = { ...this.state.priceErrors };
    if (elm.trim() !== "" && !Regex.test(elm)) {
      priceErrors[row] = "Please insert valid price";
      this.setState({ priceErrors, verifyBtn: true });
      e.target.value = "";
    } else if (elm.trim() !== "" && elm.replace(".", "").length > 20) {
      priceErrors[row] = "Price must not exceed 20 digits";
      this.setState({ priceErrors, verifyBtn: true });
    } else if (elm.trim() !== "" && elm.includes(".") && elm.split(".")[1].length > 8) {
      priceErrors[row] = "Price must not exceed 8 decimal places";
      this.setState({ priceErrors, verifyBtn: true });
    } else {
      delete priceErrors[row];
      this.setState({ priceErrors, verifyBtn: false });
    }
  };

  handleQuantity = (row, e) => {
    let elm = e.target.value;
    let Regex = /^[0-9]+(\.[0-9]+)?$/;
    let quantityErrors = { ...this.state.quantityErrors };
    if (elm.trim() !== "" && !Regex.test(elm)) {
      quantityErrors[row] = "Please insert valid quantity";
      this.setState({ quantityErrors, verifyBtn: true });
      e.target.value = "";
    } else if (elm.trim() !== "" && elm.replace(".", "").length > 20) {
      quantityErrors[row] = "Quantity must not exceed 20 digits";
      this.setState({ quantityErrors, verifyBtn: true });
    } else if (elm.trim() !== "" && elm.includes(".") && elm.split(".")[1].length > 8) {
      quantityErrors[row] = "Quantity must not exceed 8 decimal places";
      this.setState({ quantityErrors, verifyBtn: true });
    } else {
      delete quantityErrors[row];
      this.setState({ quantityErrors, verifyBtn: false });
    }
  };

  handleSetValue = (row, field, e) => {
    let currency = this.state.selectedAsset.assetCode;
    let items = this.state.items;
    let data = e.target.value;
    if (field == "item" || field == "qty") {
      for (let i = 0; i < items.length; i++) {
        console.log(row, field, data);
        if (row == items[i].row) {
          if (field == "item") {
            items[i].item = data;
            if (data.trim() !== "") {
              let itemErrors = { ...this.state.itemErrors };
              delete itemErrors[row];
              this.setState({ itemErrors });
            }
          } else if (field == "qty") {
            items[i].qty = data;
            if (data && data !== "0") {
              let quantityErrors = { ...this.state.quantityErrors };
              delete quantityErrors[row];
              this.setState({ quantityErrors });
            }
          }
        }
      }
      this.setState({ items: items }, () => {
        this.calculateTotalAmount();
      });
    } else {
      this.setState({ showLoader: true });
      GetMarketPrice(currency)
        .then(
          function (res) {
            this.setState({ showLoader: false });
            let response = res.data;
            let price = response.price;
            let convertedPrice = parseFloat(data) / parseFloat(price);
            console.log(convertedPrice);
            for (let i = 0; i < items.length; i++) {
              console.log(row, field, data);
              if (row == items[i].row) {
                items[i].fiat_price = data;
                items[i].price = convertedPrice.toFixed(6);
              }
            }
            console.log(items);
            this.setState({ items: items }, () => {
              this.calculateTotalAmount();
            });
          }.bind(this)
        )
        .catch(
          function (err) {
            this.setState({ showLoader: false });
          }.bind(this)
        );
    }
  };

  handleSelectedCurrency = (e) => {
    let code = e.target.value;
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      currency_id: code,
    };
    this.setState({ showLoader: true });
    GetMerchantSettings(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            if (
              response.accept_overpayments != "" &&
              response.accept_overpayments != null &&
              response.accept_overpayments != "no" &&
              response.accept_underpayments != "" &&
              response.accept_underpayments != null &&
              response.accept_underpayments != "no"
            ) {
              this.setState({
                selectedAsset: handleDynamicCurrencyDetiails(
                  this.state.assets,
                  code
                ),
                networkArray: handleDynamicCurrencyDetiails(
                  this.state.assets,
                  code
                ).network,
                network: handleDynamicCurrencyDetiails(this.state.assets, code)
                  .network[0],
                buttonHtml: "",
                showPreviewForButton: false,
                showPreviewForHyperlink: false,
                showPreviewForQrCode: false,
              });
            } else {
              showConfirm(
                "Set your underpayment or overpayment tolerance limits",
                "Go to Merchant Settings > Automatic Exception Handling",
                "error",
                () => {
                  localStorage.setItem(
                    SITENAMEALIAS + "_need_tolerance_setting",
                    "true"
                  );
                  localStorage.setItem(
                    SITENAMEALIAS + "_need_tolerance_setting_for_currency",
                    code
                  );
                  this.props.history.push("/settings");
                }
              );
            }
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  handleNetworkChange = (e) => {
    this.setState({
      network: e.target.value,
      buttonHtml: "",
      showPreviewForButton: false,
      showPreviewForHyperlink: false,
      showPreviewForQrCode: false,
    });
  };

  handleRenderAssets = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });
    FetchUsdBtcLedgerAmount(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          console.log(response);
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            if (response != undefined && response != null) {
              let coinBalance = response.coin_balance;
              let arr = [];
              if (coinBalance != undefined) {
                for (let i = 0; i < coinBalance.length; i++) {
                  if (coinBalance[i].currency_code != "USD") {
                    let obj = {
                      assetName: coinBalance[i].currency_name,
                      coinBalance: coinBalance[i].balance,
                      assetCode: coinBalance[i].currency_code,
                      assetId: coinBalance[i].currency_id,
                      assetImage: coinBalance[i].logo,
                      network: coinBalance[i].network,
                      isBrokerCurrency: coinBalance[i].is_broker_currency,
                    };
                    arr.push(obj);
                  }
                }
              } else {
              }
              const currencyOrder = ['USDC', 'USDT', 'XRP', 'DOGE', 'HCX', 'ETH', 'BTC', 'LTC', 'BCH'];
              arr.sort((a, b) => {
                const idxA = currencyOrder.indexOf(a.assetCode);
                const idxB = currencyOrder.indexOf(b.assetCode);
                return (idxA === -1 ? 999 : idxA) - (idxB === -1 ? 999 : idxB);
              });
              this.setState({ assets: arr }, () => {
                console.log(this.state.assets);
                localStorage.setItem(
                  SITENAMEALIAS + "_assets",
                  JSON.stringify(this.state.assets)
                );
              });
            }
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  getPaymentLink = () => {
    const previewFormAction =
      window.location.origin + "/merchant/init-payment.html";
    return (
      previewFormAction +
      "?email_bill_id=" +
      this.state.encodedValue +
      "&quantity=" +
      this.state.selectedQty
    );
  };

  copyLinkToClipboard = () => {
    const link = this.getPaymentLink();
    navigator.clipboard
      .writeText(link)
      .then(() => {
        showToast("success", "Payment link copied to clipboard");
      })
      .catch(() => {
        const tempInput = document.createElement("input");
        tempInput.value = link;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);
        showToast("success", "Payment link copied to clipboard");
      });
  };

  copyCodeToClipboard = () => {
    const el = this.textArea;
    el.select();
    document.execCommand("copy");
    showToast("success", "Successfully copied to clipboard");
  };

  generateHyperLink = () => {
    if (this.state.emailBillId != "") {
      let link = this.getPaymentLink();
      let html = '<a href="' + link + '" target="_blank">Pay Now</a>';
      this.setState({
        buttonHtml: html,
        showPreviewForButton: false,
        showPreviewForHyperlink: true,
        showPreviewForQrCode: false,
      });
    } else {
      showToast(
        "error",
        "No Email Bill Id found, you need to save your details first"
      );
    }
  };

  generateQrCode = () => {
    if (this.state.emailBillId != "") {
      let url = this.getPaymentLink();
      this.setState(
        {
          buttonHtml: "",
          qrCodeLink: url,
          showPreviewForButton: false,
          showPreviewForHyperlink: false,
          showPreviewForQrCode: true,
          buttonImageUrl: "",
        },
        () => {
          let element = document.getElementById("qrCodeHtml").innerHTML;
          this.setState({ buttonHtml: element });
        }
      );
    } else {
      showToast(
        "error",
        "No Email Bill Id found, you need to save your details first"
      );
    }
  };

  handleGenerateButton = (size) => {
    if (this.state.emailBillId != "") {
      const previewFormAction =
        window.location.origin + "/merchant/init-payment.html";
      let imageText = "",
        buttonStyle = "",
        buttonImageStyle = "",
        buttonTextStyle = "";
      if (size == "small") {
        imageText = "sm-button-";
        buttonStyle = "width:80px;height:43px;";
        buttonImageStyle = "width:16px;";
        buttonTextStyle = "font-size:10px;";
      } else if (size == "medium") {
        imageText = "md-button-";
        buttonStyle = "width:105px;height:56px;";
        buttonImageStyle = "width:33px;";
        buttonTextStyle = "font-size:12px;";
      } else {
        imageText = "lg-button-";
        buttonStyle = "width:132px;height:70px;";
        buttonImageStyle = "width:40px;";
        buttonTextStyle = "font-size:12px;";
      }
      let html = "";
      html += ' <div style="display:block;" id="paynow_button_form_container">';
      html +=
        '<form method="GET" action="' +
        previewFormAction +
        '" target="_blank">';
      html +=
        '<input type="hidden" name="email_bill_id" value="' +
        this.state.encodedValue +
        '"/>';
      html += '<table border="0"><tbody><tr>';
      html +=
        '<td style="padding:5px;" align="center" valign="middle"><label>Qty:</label></td>';
      html +=
        '<td style="padding:5px;" align="center" valign="middle"><input min="1" required name="quantity" type="number" value="' +
        this.state.selectedQty +
        '" style="border-radius:4px; border:1px solid #ccc; height:42px; width:60px; padding:6px; " /></td>';
      html +=
        '<td style="padding:5px;" align="center" valign="middle"><button style="padding:0; border:0;background : #102ab3;color:#fff; ' +
        buttonStyle +
        '" type="submit" ><img  src="' +
        this.assetDetailsForButtons(this.state.selectedAsset.assetId)
          .assetImage +
        '" style="' +
        buttonImageStyle +
        '"/> <span style="' +
        buttonTextStyle +
        '">Pay Now</span></button></td>';
      html += "</tr></tbody></table></form></div>";
      this.setState({
        buttonHtml: html,
        selectedButtonSize: size,
        showPreviewForButton: true,
        showPreviewForHyperlink: false,
        showPreviewForQrCode: false,
        buttonImageUrl:
          FILEPATH +
          "/" +
          imageText +
          this.state.selectedAsset.assetCode +
          ".png",
        previewFormAction: previewFormAction,
      });
    } else {
      showToast(
        "error",
        "No Email Bill Id found, you need to save your details first"
      );
    }
  };

  assetDetailsForButtons = (assetId) => {
    let assets = this.state.assets;
    let result = {};
    for (let i = 0; i < assets.length; i++) {
      if (assetId == assets[i].assetId) {
        result = assets[i];
        break;
      }
    }
    return result;
  };

  componentDidMount() {
    this.renderMerchantProcessingFeeType();
    this.handleRenderAssets();
    const defaultAsset = handleCurrencyDetiails(148);
    this.setState(
      {
        selectedAsset: handleCurrencyDetiails(148),
        networkArray: handleNetworkDetails(148),
        network: initialiseNetwork(148),
        items: [{ row: 1, item: "", qty: 0, price: 0.0 }],
      },
      () => {
        console.log(this.state.selectedAsset);
        this.handleDateChange(new Date());
        // ── Fetch txn charge for default currency on mount ──
        this.fetchTxnCharge(defaultAsset.assetCode);
      }
    );
  }

  renderAddressFields() {
    if (!this.state.checked) return null;
    return (
      <div style={{ gridColumn: "1 / -1" }}>
        <div style={{ ...styles.formGrid, marginTop: "8px" }}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Address Line 1 *</label>
            <input
              type="text"
              style={styles.input}
              ref={this.address1Ref}
              onBlur={this.handleAddr1}
              placeholder="Enter address line 1"
            />
            {this.state.addr1 && (
              <span style={styles.errorText}>Please insert valid address</span>
            )}
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Address Line 2</label>
            <input
              type="text"
              style={styles.input}
              ref={this.address2Ref}
              onBlur={this.handleAddr2}
              placeholder="Enter address line 2"
            />
            {this.state.addr2 && (
              <span style={styles.errorText}>Please insert valid address</span>
            )}
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>City *</label>
            <input
              type="text"
              style={styles.input}
              ref={this.cityRef}
              onBlur={this.handleCity}
              placeholder="Enter city"
            />
            {this.state.city && (
              <span style={styles.errorText}>
                Please insert valid city name
              </span>
            )}
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>State *</label>
            <input
              type="text"
              style={styles.input}
              ref={this.stateRef}
              onBlur={this.handleState}
              placeholder="Enter state"
            />
            {this.state.stateName && (
              <span style={styles.errorText}>
                Please insert valid state name
              </span>
            )}
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Country *</label>
            <select style={styles.select} ref={this.countryRef}>
              <option value="">Select Country</option>
              {COUNTRYLIST.map((iter, i) => (
                <option key={iter + "_" + i} value={iter}>
                  {iter}
                </option>
              ))}
            </select>
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Zip Code *</label>
            <input
              type="text"
              style={styles.input}
              ref={this.zipRef}
              onBlur={this.handleZipcode}
              placeholder="Enter zip code"
            />
            {this.state.zipcode && (
              <span style={styles.errorText}>Please insert valid zipcode</span>
            )}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { processingFeeHandling, txnCharge } = this.state;

    const feeOptionStyle = (val) => ({
      flex: 1,
      display: "flex",
      alignItems: "flex-start",
      gap: "12px",
      padding: "14px 16px",
      borderRadius: "12px",
      border:
        processingFeeHandling === val
          ? "1.5px solid var(--btn-color)"
          : "1.5px solid var(--body-color-less2)",
      background:
        processingFeeHandling === val
          ? "color-mix(in srgb, var(--btn-color), transparent 93%)"
          : "var(--body-color)",
      cursor: "pointer",
      userSelect: "none",
      transition: "all 0.15s ease",
    });

    const radioDotStyle = (val) => ({
      width: "16px",
      height: "16px",
      borderRadius: "50%",
      border:
        processingFeeHandling === val
          ? "5px solid var(--btn-color)"
          : "2px solid color-mix(in srgb, var(--text-color), transparent 55%)",
      background: "var(--body-color)",
      flexShrink: 0,
      marginTop: "2px",
      transition: "all 0.15s ease",
    });

    return (
      <Fragment>
        <div className="container-scroller">
          <Sidebar />
          <Header />

          <div className="main-panel">
            <div style={styles.pageWrapper}>
              {/* Back + Title */}
              <div style={styles.backRow}>
                <div style={styles.backBtn} onClick={this.handleBack}>
                  <FontAwesomeIcon icon={faArrowLeft} />
                </div>
                <div>
                  <h2 style={styles.pageTitle}>
                    {this.state.action == "add"
                      ? "Create and Email Invoices"
                      : "Edit and Email Invoices"}
                  </h2>
                  <div style={styles.pageSubtitle}>
                    Fill in the details to generate and send an email bill to
                    your customer
                  </div>
                </div>
              </div>

              {/* Buyer Information Card */}
              <div style={styles.card}>
                <div style={styles.cardHeader}>
                  <div
                    style={{
                      ...styles.cardHeaderIcon,
                      background:
                        "linear-gradient(135deg, color-mix(in srgb, var(--btn-color) 15%, transparent), color-mix(in srgb, var(--btn-color) 5%, transparent))",
                      color: "var(--btn-color)",
                    }}
                  >
                    <i className="mdi mdi-account-outline" />
                  </div>
                  <h4 style={styles.cardHeaderTitle}>Buyer Information</h4>
                </div>
                <div style={styles.cardBody}>
                  <div style={styles.formGrid}>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Email Address *</label>
                      <input
                        type="email"
                        style={styles.input}
                        ref={this.emailRef}
                        onBlur={this.handleEmail}
                        placeholder="Enter customer email"
                      />
                      {this.state.emailAddr && (
                        <span style={styles.errorText}>
                          Please insert valid email address
                        </span>
                      )}
                    </div>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Customer Name *</label>
                      <input
                        type="text"
                        style={styles.input}
                        ref={this.firstNameRef}
                        onBlur={this.handleCustName}
                        placeholder="Enter customer name"
                      />
                      {this.state.custName && (
                        <span style={styles.errorText}>
                          Please insert valid name
                        </span>
                      )}
                    </div>
                    <div style={styles.checkboxRow}>
                      <input
                        type="checkbox"
                        style={styles.checkbox}
                        id="include_address_cb"
                        defaultChecked={this.state.checked}
                        onChange={this.handleChange}
                      />
                      <label
                        htmlFor="include_address_cb"
                        style={styles.checkboxLabel}
                      >
                        Include buyer address
                      </label>
                    </div>
                    {this.renderAddressFields()}
                  </div>
                </div>
              </div>

              {/* Bill Details Card */}
              <div style={styles.card}>
                <div style={styles.cardHeader}>
                  <div
                    style={{
                      ...styles.cardHeaderIcon,
                      background:
                        "linear-gradient(135deg, color-mix(in srgb, #8b5cf6 15%, transparent), color-mix(in srgb, #8b5cf6 5%, transparent))",
                      color: "#8b5cf6",
                    }}
                  >
                    <i className="mdi mdi-file-document-outline" />
                  </div>
                  <h4 style={styles.cardHeaderTitle}>Bill Details</h4>
                </div>
                <div style={styles.cardBody}>
                  <div style={styles.formGrid}>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Currency</label>
                      <select
                        style={styles.select}
                        onChange={(e) => this.handleSelectedCurrency(e)}
                      >
                        {this.state.assets.map((item) => (
                          <option key={item.assetId} value={item.assetId}>
                            {item.assetCode} - {item.assetName}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Network</label>
                      {this.state.networkArray.length > 1 ? (
                        <select
                          style={styles.select}
                          onChange={(e) => this.handleNetworkChange(e)}
                        >
                          {this.state.networkArray.map((network) => (
                            <option key={network} value={network}>
                              {network}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <input
                          type="text"
                          style={styles.select}
                          value={this.state.networkArray[0] || ""}
                          disabled
                        />
                      )}
                    </div>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Due Date</label>
                      <DatePicker
                        selected={this.state.selectedDate}
                        dateFormat="yyyy-MM-dd"
                        placeholderText="Please choose a date"
                        className="form-control w-100"
                        onChange={(date) => {
                          this.handleDateChange(date);
                        }}
                        wrapperClassName="w-100"
                        customInput={<input type="text" style={styles.input} />}
                      />
                    </div>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Bill Number *</label>
                      <input
                        type="text"
                        style={styles.input}
                        ref={this.billNumberRef}
                        onBlur={this.handleBillNo}
                        placeholder="Enter bill number"
                      />
                      {this.state.billNumber && (
                        <span style={styles.errorText}>
                          Please insert valid bill number
                        </span>
                      )}
                    </div>
                    <div style={styles.checkboxRow}>
                      <input
                        type="checkbox"
                        style={styles.checkbox}
                        id="recurring_bill_cb"
                        checked={this.state.isRecurringBillChecked}
                        onClick={() => {
                          this.setState({
                            isRecurringBillChecked:
                              !this.state.isRecurringBillChecked,
                          });
                        }}
                      />
                      <label
                        htmlFor="recurring_bill_cb"
                        style={styles.checkboxLabel}
                      >
                        This is a recurring bill
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              {/* ══ Processing Fee Handling Card ══ */}
              <div style={styles.card}>
                <div style={styles.cardHeader}>
                  <div
                    style={{
                      ...styles.cardHeaderIcon,
                      background:
                        "linear-gradient(135deg, color-mix(in srgb, #14b8a6 15%, transparent), color-mix(in srgb, #14b8a6 5%, transparent))",
                      color: "#14b8a6",
                    }}
                  >
                    <i className="fa fa-percent" />
                  </div>
                  <h4 style={styles.cardHeaderTitle}>
                    Processing Fee Handling
                  </h4>
                </div>
                <div style={styles.cardBody}>
                  <p
                    style={{
                      fontSize: "13px",
                      color: "var(--text-color)",
                      opacity: 0.6,
                      margin: "0 0 16px",
                    }}
                  >
                    Choose how transaction fees are applied for this bill.
                  </p>
                  <div style={{ display: "flex", gap: "14px" }}>
                    {/* Option 1 — Customer pays */}
                    <div
                      style={feeOptionStyle("customer")}
                      onClick={() =>
                        this.setState({ processingFeeHandling: "customer" })
                      }
                    >
                      <div style={radioDotStyle("customer")} />
                      <div>
                        <div
                          style={{
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "var(--text-color)",
                            marginBottom: "3px",
                          }}
                        >
                          Customer pays the processing fee
                        </div>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "var(--text-color)",
                            opacity: 0.5,
                          }}
                        >
                          The fee will be added to the checkout total.
                        </div>
                      </div>
                    </div>
                    {/* Option 2 — Merchant absorbs */}
                    <div
                      style={feeOptionStyle("merchant")}
                      onClick={() =>
                        this.setState({ processingFeeHandling: "merchant" })
                      }
                    >
                      <div style={radioDotStyle("merchant")} />
                      <div>
                        <div
                          style={{
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "var(--text-color)",
                            marginBottom: "3px",
                          }}
                        >
                          Merchant absorbs the processing fee
                        </div>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "var(--text-color)",
                            opacity: 0.5,
                          }}
                        >
                          The fee will be deducted from your payout.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* ══ End Processing Fee Handling Card ══ */}

              {/* Line Items Card */}
              <div style={styles.card}>
                <div
                  style={{
                    ...styles.cardHeader,
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <div
                      style={{
                        ...styles.cardHeaderIcon,
                        background:
                          "linear-gradient(135deg, color-mix(in srgb, #10b981 15%, transparent), color-mix(in srgb, #10b981 5%, transparent))",
                        color: "#10b981",
                      }}
                    >
                      <i className="mdi mdi-cart-outline" />
                    </div>
                    <h4 style={styles.cardHeaderTitle}>Line Items</h4>
                  </div>
                  <button
                    type="button"
                    style={styles.addItemBtn}
                    onClick={() => this.addNewTableRow()}
                  >
                    <i className="mdi mdi-plus" /> Add Item
                  </button>
                </div>

                <div style={{ overflowX: "auto" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr>
                        <th style={styles.th}>Item</th>
                        <th style={styles.th}>Price ($)</th>
                        <th style={{ ...styles.th, position: "relative" }}>
                          Crypto Price ({this.state.selectedAsset.assetCode})
                          <span
                            className="tooltip-container"
                            style={styles.infoTip}
                          >
                            <i
                              className="fa fa-info-circle info-icon"
                              style={{ fontSize: "12px", opacity: 0.5 }}
                            ></i>
                            <span
                              className="tooltip-text"
                              style={{ textAlign: "justify" }}
                            >
                              The amount in crypto shown here is indicative.
                              This amount in crypto shown here is equivalent to
                              the USD amount at the current market price of the
                              crypto. When the payment is actually made, the
                              system will check the market price of crypto at
                              that time and deduct the equivalent amount of
                              crypto for the USD amount payable here.
                            </span>
                          </span>
                        </th>
                        <th style={styles.th}>Quantity</th>
                        <th style={{ ...styles.th, textAlign: "right" }}>
                          Amount
                        </th>
                        <th
                          style={{
                            ...styles.th,
                            textAlign: "center",
                            width: "60px",
                          }}
                        ></th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.items.map((item) => (
                        <tr key={item.row}>
                          <td style={styles.td}>
                            <input
                              type="text"
                              style={{
                                ...styles.tableInput,
                                ...(this.state.itemErrors[item.row] ? { borderColor: "#ef4444" } : {}),
                              }}
                              onChange={(e) => {
                                this.handleSetValue(item.row, "item", e);
                              }}
                              onBlur={(e) => this.handleItemName(item.row, e)}
                              value={item.item}
                              placeholder="Item name *"
                            />
                            {this.state.itemErrors[item.row] && (
                              <span style={styles.errorText}>
                                {this.state.itemErrors[item.row]}
                              </span>
                            )}
                          </td>
                          <td style={styles.td}>
                            <input
                              type="number"
                              style={{
                                ...styles.tableInput,
                                ...(this.state.priceErrors[item.row] ? { borderColor: "#ef4444" } : {}),
                              }}
                              onKeyUp={(e) => {
                                this.handleSetValue(item.row, "price", e);
                              }}
                              onBlur={(e) => this.handlePrice(item.row, e)}
                              placeholder="0.00"
                            />
                            {this.state.priceErrors[item.row] && (
                              <span style={styles.errorText}>
                                {this.state.priceErrors[item.row]}
                              </span>
                            )}
                          </td>
                          <td style={styles.td}>
                            <input
                              type="number"
                              style={{
                                ...styles.tableInput,
                                opacity: 0.6,
                                cursor: "not-allowed",
                              }}
                              value={item.price}
                              disabled
                            />
                          </td>
                          <td style={styles.td}>
                            <input
                              type="number"
                              min="1"
                              style={{
                                ...styles.tableInput,
                                ...(this.state.quantityErrors[item.row] ? { borderColor: "#ef4444" } : {}),
                              }}
                              onChange={(e) => {
                                this.handleSetValue(item.row, "qty", e);
                              }}
                              onBlur={(e) => this.handleQuantity(item.row, e)}
                              value={item.qty}
                              placeholder="0"
                            />
                            {this.state.quantityErrors[item.row] && (
                              <span style={styles.errorText}>
                                {this.state.quantityErrors[item.row]}
                              </span>
                            )}
                          </td>
                          <td style={{ ...styles.td, textAlign: "right" }}>
                            <span
                              style={{
                                fontWeight: "600",
                                fontFamily: "'SF Mono', 'Fira Code', monospace",
                                fontSize: "13px",
                              }}
                            >
                              <span
                                style={{ opacity: 0.5, marginRight: "4px" }}
                              >
                                {this.state.selectedAsset.assetCode}
                              </span>
                              {item.price != "" && item.qty != ""
                                ? (
                                    parseFloat(item.price) *
                                    parseFloat(item.qty)
                                  ).toFixed(6)
                                : "0.00"}
                            </span>
                          </td>
                          <td style={{ ...styles.td, textAlign: "center" }}>
                            <button
                              type="button"
                              style={styles.deleteBtn}
                              onClick={() => {
                                showConfirm(
                                  "Delete",
                                  "Are you sure you want to delete this item?",
                                  "warning",
                                  () => this.handleDeleteRow(item.row)
                                );
                              }}
                            >
                              <i className="mdi mdi-delete-forever" />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Total */}
                <div style={styles.totalRow}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <span style={styles.totalLabel}>Total</span>
                    <span className="tooltip-container" style={styles.infoTip}>
                      <i
                        className="fa fa-info-circle info-icon"
                        style={{ fontSize: "12px", opacity: 0.4 }}
                      ></i>
                      <span className="tooltip-text">
                        The amount in crypto shown here is indicative. When the
                        payment is actually made, the system will check the
                        market price of crypto at that time and deduct the
                        equivalent amount.
                      </span>
                    </span>
                  </div>
                  <span style={styles.totalAmount}>
                    {this.state.selectedAsset != null &&
                      this.state.selectedAsset.assetCode}{" "}
                    {this.state.totalAmount}
                  </span>
                </div>
              </div>

              {/* Submit */}
              <div style={styles.submitFooter}>
                <button
                  type="button"
                  style={
                    this.state.verifyBtn
                      ? styles.btnPrimaryDisabled
                      : styles.btnPrimary
                  }
                  onClick={() => {
                    this.handleEmailBilling();
                  }}
                  disabled={this.state.verifyBtn}
                >
                  Save & Send Bill
                </button>
              </div>

              {/* Payment Link Card */}
              <div style={styles.paymentLinkCard}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    marginBottom: "16px",
                  }}
                >
                  <div
                    style={{
                      ...styles.cardHeaderIcon,
                      background:
                        "linear-gradient(135deg, color-mix(in srgb, #f59e0b 15%, transparent), color-mix(in srgb, #f59e0b 5%, transparent))",
                      color: "#f59e0b",
                    }}
                  >
                    <i className="mdi mdi-link-variant" />
                  </div>
                  <h4 style={styles.cardHeaderTitle}>Payment Link</h4>
                </div>
                <div style={styles.paymentLinkBox}>
                  <input
                    type="text"
                    style={styles.paymentLinkInput}
                    value={this.state.emailBillId ? this.getPaymentLink() : ""}
                    readOnly
                    placeholder="Save your bill details to generate a payment link"
                  />
                  <button
                    type="button"
                    style={{
                      ...styles.copyBtn,
                      opacity: this.state.emailBillId ? 1 : 0.4,
                      cursor: this.state.emailBillId
                        ? "pointer"
                        : "not-allowed",
                    }}
                    onClick={() => this.copyLinkToClipboard()}
                    disabled={!this.state.emailBillId}
                  >
                    <i className="fa fa-copy" /> Copy
                  </button>
                  <button
                    type="button"
                    style={{
                      ...styles.copyBtn,
                      opacity: this.state.emailBillId ? 1 : 0.4,
                      cursor: this.state.emailBillId
                        ? "pointer"
                        : "not-allowed",
                    }}
                    onClick={() => this.state.emailBillId && window.open(this.getPaymentLink(), "_blank")}
                    disabled={!this.state.emailBillId}
                  >
                    <i className="fa fa-external-link" /> Open
                  </button>
                </div>
              </div>

              {/* Button Code Card */}
              <div style={styles.card}>
                <div style={styles.cardHeader}>
                  <div
                    style={{
                      ...styles.cardHeaderIcon,
                      background:
                        "linear-gradient(135deg, color-mix(in srgb, #10b981 15%, transparent), color-mix(in srgb, #10b981 5%, transparent))",
                      color: "#10b981",
                    }}
                  >
                    <i className="mdi mdi-code-tags" />
                  </div>
                  <h4 style={styles.cardHeaderTitle}>Button Code</h4>
                </div>
                <div style={styles.cardBody}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "16px",
                    }}
                  >
                    <label style={{ ...styles.label, margin: 0 }}>
                      Generated HTML Code
                    </label>
                    <button
                      type="button"
                      style={styles.copyBtn}
                      onClick={() => this.copyCodeToClipboard()}
                    >
                      <i className="fa fa-copy" /> Copy Code
                    </button>
                  </div>

                  <div style={styles.tabContainer}>
                    <button
                      type="button"
                      style={
                        this.state.activeGenerateTab === "button"
                          ? styles.tabActive
                          : styles.tab
                      }
                      onClick={() =>
                        this.setState({ activeGenerateTab: "button" })
                      }
                    >
                      <i className="mdi mdi-gesture-tap-button" /> Button
                    </button>
                    <button
                      type="button"
                      style={
                        this.state.activeGenerateTab === "qrcode"
                          ? styles.tabActive
                          : styles.tab
                      }
                      onClick={() =>
                        this.setState({ activeGenerateTab: "qrcode" })
                      }
                    >
                      <i className="mdi mdi-qrcode" /> QR Code
                    </button>
                    <button
                      type="button"
                      style={
                        this.state.activeGenerateTab === "hyperlink"
                          ? styles.tabActive
                          : styles.tab
                      }
                      onClick={() =>
                        this.setState({ activeGenerateTab: "hyperlink" })
                      }
                    >
                      <i className="mdi mdi-link" /> Hyperlink
                    </button>
                  </div>

                  <div style={styles.tabContent}>
                    {this.state.activeGenerateTab === "button" && (
                      <div>
                        <label
                          style={{
                            ...styles.label,
                            marginBottom: "10px",
                            display: "block",
                          }}
                        >
                          Select Button Size
                        </label>
                        <div style={styles.buttonSizeOptions}>
                          <button
                            type="button"
                            style={
                              this.state.selectedButtonSize === "small"
                                ? styles.sizeBtnActive
                                : styles.sizeBtn
                            }
                            onClick={() => this.handleGenerateButton("small")}
                          >
                            <i
                              className="mdi mdi-checkbox-blank-outline"
                              style={{ fontSize: "11px" }}
                            />{" "}
                            80 x 43 px
                          </button>
                          <button
                            type="button"
                            style={
                              this.state.selectedButtonSize === "medium"
                                ? styles.sizeBtnActive
                                : styles.sizeBtn
                            }
                            onClick={() => this.handleGenerateButton("medium")}
                          >
                            <i
                              className="mdi mdi-checkbox-blank-outline"
                              style={{ fontSize: "13px" }}
                            />{" "}
                            105 x 56 px
                          </button>
                          <button
                            type="button"
                            style={
                              this.state.selectedButtonSize === "large"
                                ? styles.sizeBtnActive
                                : styles.sizeBtn
                            }
                            onClick={() => this.handleGenerateButton("large")}
                          >
                            <i
                              className="mdi mdi-checkbox-blank-outline"
                              style={{ fontSize: "15px" }}
                            />{" "}
                            132 x 70 px
                          </button>
                        </div>
                      </div>
                    )}
                    {this.state.activeGenerateTab === "qrcode" && (
                      <div style={{ textAlign: "center" }}>
                        <button
                          type="button"
                          style={{
                            ...styles.btnPrimary,
                            opacity: this.state.emailBillId ? 1 : 0.5,
                            cursor: this.state.emailBillId
                              ? "pointer"
                              : "not-allowed",
                          }}
                          onClick={() => this.generateQrCode()}
                          disabled={!this.state.emailBillId}
                        >
                          <i className="mdi mdi-qrcode" /> Generate QR Code
                        </button>
                      </div>
                    )}
                    {this.state.activeGenerateTab === "hyperlink" && (
                      <div style={{ textAlign: "center" }}>
                        <button
                          type="button"
                          style={{
                            ...styles.btnPrimary,
                            opacity: this.state.emailBillId ? 1 : 0.5,
                            cursor: this.state.emailBillId
                              ? "pointer"
                              : "not-allowed",
                          }}
                          onClick={() => this.generateHyperLink()}
                          disabled={!this.state.emailBillId}
                        >
                          <i className="mdi mdi-link" /> Generate Hyperlink
                        </button>
                      </div>
                    )}
                  </div>

                  <div
                    style={{ ...styles.sectionDivider, margin: "20px 0 16px" }}
                  />

                  <div
                    style={{
                      fontSize: "12px",
                      color: "var(--text-color)",
                      opacity: 0.5,
                      marginBottom: "8px",
                    }}
                  >
                    Select all of the HTML code below, then copy and paste it
                    into your webpage.
                  </div>
                  <textarea
                    style={styles.codeArea}
                    ref={(textarea) => (this.textArea = textarea)}
                    value={this.state.buttonHtml}
                  />

                  <div
                    style={{ ...styles.sectionDivider, margin: "20px 0 16px" }}
                  />

                  <div>
                    <label
                      style={{
                        ...styles.label,
                        marginBottom: "10px",
                        display: "block",
                      }}
                    >
                      Preview
                    </label>
                    <div style={styles.previewBox}>
                      {!this.state.showPreviewForButton &&
                        !this.state.showPreviewForHyperlink &&
                        !this.state.showPreviewForQrCode && (
                          <span style={styles.previewPlaceholder}>
                            Select a tab above and generate to see the preview
                          </span>
                        )}
                      {this.state.showPreviewForButton && (
                        <div id="paynow_button_form_container">
                          <form
                            method="GET"
                            action={this.state.previewFormAction}
                            target="_blank"
                          >
                            <input
                              type="hidden"
                              name="email_bill_id"
                              value={this.state.encodedValue}
                            />
                            <table border="0">
                              <tbody>
                                <tr>
                                  <td
                                    style={{ padding: "5px" }}
                                    align="center"
                                    valign="middle"
                                  >
                                    <label>Qty:</label>
                                  </td>
                                  <td
                                    style={{ padding: "5px" }}
                                    align="center"
                                    valign="middle"
                                  >
                                    <input
                                      min="1"
                                      required
                                      name="quantity"
                                      type="number"
                                      value={this.state.selectedQty}
                                      onChange={(e) => {
                                        if (!isNaN(e.target.value)) {
                                          this.setState(
                                            { selectedQty: e.target.value },
                                            () => {
                                              this.handleGenerateButton(
                                                this.state.selectedButtonSize
                                              );
                                            }
                                          );
                                        }
                                      }}
                                      style={{
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                        height: "42px",
                                        width: "60px",
                                        padding: "6px",
                                      }}
                                    />
                                  </td>
                                  <td
                                    style={{ padding: "5px" }}
                                    align="center"
                                    valign="middle"
                                  >
                                    <button
                                      type="submit"
                                      style={
                                        this.state.selectedButtonSize ===
                                        "small"
                                          ? {
                                              borderRadius: "4px",
                                              border: "solid #fff",
                                              background: "#102ab3",
                                              color: "#fff",
                                              width: "80px",
                                              height: "43px",
                                            }
                                          : this.state.selectedButtonSize ===
                                            "large"
                                          ? {
                                              borderRadius: "4px",
                                              border: "solid #fff",
                                              background: "#102ab3",
                                              color: "#fff",
                                              width: "132px",
                                              height: "70px",
                                            }
                                          : {
                                              borderRadius: "4px",
                                              border: "solid #fff",
                                              background: "#102ab3",
                                              color: "#fff",
                                              width: "105px",
                                              height: "56px",
                                            }
                                      }
                                    >
                                      <img
                                        src={
                                          this.assetDetailsForButtons(
                                            this.state.selectedAsset.assetId
                                          ).assetImage
                                        }
                                        style={
                                          this.state.selectedButtonSize ===
                                          "small"
                                            ? { width: "16px" }
                                            : this.state.selectedButtonSize ===
                                              "large"
                                            ? { width: "40px" }
                                            : { width: "33px" }
                                        }
                                      />{" "}
                                      <span
                                        style={
                                          this.state.selectedButtonSize ===
                                          "small"
                                            ? { fontSize: "10px" }
                                            : { fontSize: "12px" }
                                        }
                                      >
                                        Pay Now
                                      </span>
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </form>
                        </div>
                      )}
                      {this.state.showPreviewForHyperlink && (
                        <div>
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={this.getPaymentLink()}
                            style={{
                              color: "var(--btn-color)",
                              fontWeight: "600",
                              fontSize: "14px",
                            }}
                          >
                            Pay Now
                          </a>
                        </div>
                      )}
                      {this.state.showPreviewForQrCode && (
                        <div id="qrCodeHtml">
                          <QRCodeSVG value={this.state.qrCodeLink} />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
          <Loader show={this.state.showLoader} />
        </div>
      </Fragment>
    );
  }
}

export default withRouter(NewEmailbilling);
